import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

const BlinkingCursor = styled('span')({
  animation: 'blink 1s infinite',
  '@keyframes blink': {
    '0%, 50%': { opacity: 1 },
    '51%, 100%': { opacity: 0 },
  },
});

const TypewriterText = ({
  texts,
  speed = 50,
  ...props
}: {
  texts: string[];
  speed: number;
  [key: string]: unknown;
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = texts[currentTextIndex];

    if (isDeleting) {
      // Deleting effect
      if (displayText.length > 0) {
        const timer = setTimeout(() => {
          setDisplayText((prev) => prev.slice(0, -1));
        }, speed / 2);
        return () => clearTimeout(timer);
      }
      // Finished deleting, move to next text
      setIsDeleting(false);
      setCurrentTextIndex((prev) => (prev + 1) % texts.length);
      setCurrentCharIndex(0);
      return undefined;
    }
    // Typing effect
    if (currentCharIndex < currentText.length) {
      const timer = setTimeout(() => {
        setDisplayText((prev) => prev + currentText[currentCharIndex]);
        setCurrentCharIndex((prev) => prev + 1);
      }, speed);
      return () => clearTimeout(timer);
    }
    // Finished typing current text, wait then start deleting
    const timer = setTimeout(() => {
      setIsDeleting(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, [currentTextIndex, currentCharIndex, isDeleting, speed, displayText.length]);

  return (
    <Typography {...props}>
      {displayText}
      <BlinkingCursor>|</BlinkingCursor>
    </Typography>
  );
};

export default TypewriterText;
